import React, { useEffect, useState } from 'react';
import { completeDeveloperLogin } from 'src/services/developerOAuth';

function DeveloperOAuthCallback() {
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    completeDeveloperLogin()
      .then((returnTo) => { window.location.replace(returnTo); })
      .catch((reason) => {
        if (active) setError(reason.message || 'AutoAppy authentication failed.');
      });

    return () => { active = false; };
  }, []);

  if (error) {
    return (
      <div role="alert" style={{ margin: '2rem', padding: '1.5rem' }}>
        <p>{error}</p>
        <a href="/">Return to the application</a>
      </div>
    );
  }

  return <div style={{ padding: '2rem' }}>Connecting to AutoAppy…</div>;
}

export default DeveloperOAuthCallback;
